"use client"
import { useState, useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import HomePage from "./components/HeroSection/HeroSection"
import AboutPage from "./components/AboutSection/About"
import MenuPage from "./components/Menu/Menu"
import PromotionRestaurant from "./components/promotionRestaurants/PromotionRestaurant"
import Testimonials from "./components/Testmonials/Testmonial"
import Feature from "./components/Feature/feature"
import GalleryPage from "./components/Gallery/Gallery"
import ContactPage from "./components/Contact/Contact"
import Header from "./components/Header/Header"
import Footer from "./components/Footer/Footer"
import LoadingScreen from "./components/LoadingScreen"
import "./App.css"
import "./ComingSoonModal.css"

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
      setIsModalOpen(true)
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <div className="min-vh-100 bg-light overflow-hidden">
      <Header />
      <main>
        <section id="home"><HomePage /></section>
        <section id="features"><Feature /></section>
        <section id="about"><AboutPage /></section>
        <section id="promotion-restaurants"><PromotionRestaurant /></section>
        <section id="testimonials"><Testimonials /></section>
        <section id="menu"><MenuPage /></section>
        <section id="gallery"><GalleryPage /></section>
        <section id="contact"><ContactPage /></section>
      </main>
      <Footer />
<AnimatePresence>
  {isModalOpen && (
    <>
      {/* Backdrop */}
      <motion.div
        className="modal-backdrop fade show"
        style={{ zIndex: 1040 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.6 }}
        exit={{ opacity: 0 }}
        onClick={() => setIsModalOpen(false)}
      />

      {/* Modal */}
      <motion.div
        className="modal d-block"
        style={{ zIndex: 1050 }}
        initial={{ opacity: 0, y: 50, scale: 0.9 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 50, scale: 0.9 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div
            className="modal-content position-relative overflow-hidden"
            style={{
                  background: "linear-gradient(218deg, #2c681a, #2a8b12 50%, #6eaa5f)",

        
              minHeight: "420px",
              borderRadius: "20px"
            }}
          >
            {/* Close Button */}
            <button
              type="button"
              className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
              style={{ zIndex: 2000 }}
              onClick={() => setIsModalOpen(false)}
            ></button>

            {/* Floating Icons - Behind Text */}
            <div style={{ position: "absolute", inset: 0, zIndex: 1 }}>
              {[
                { src: "https://cdn-icons-png.flaticon.com/512/1404/1404945.png", top: "20%", left: "8%" },
                { src: "https://cdn-icons-png.flaticon.com/512/3075/3075977.png", top: "25%", right: "10%" },
                { src: "https://cdn-icons-png.flaticon.com/512/1046/1046784.png", bottom: "10%", left: "25%" },
                { src: "https://cdn-icons-png.flaticon.com/512/1046/1046786.png", top: "55%", left: "5%" },
                { src: "https://cdn-icons-png.flaticon.com/512/1483/1483336.png", bottom: "25%", right: "10%" },
                { src: "https://cdn-icons-png.flaticon.com/512/3075/3075976.png", top: "18%", left: "45%" },
                { src: "https://cdn-icons-png.flaticon.com/512/893/893257.png", bottom: "10%", right: "35%" }
              ].map((icon, index) => (
                <motion.img
                  key={index}
                  src={icon.src}
                  alt="Floating Icon"
                  className="position-absolute"
                  style={{
                    width: 60,
                    opacity: 0.7,
                    filter: "drop-shadow(2px 4px 6px rgba(0,0,0,0.3))",
                    ...icon
                  }}
                  animate={{
                    y: [0, -15, 0],
                    rotate: [0, 10, -10, 0]
                  }}
                  transition={{
                    duration: 4 + index * 0.5,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                />
              ))}
            </div>

            {/* Text Content - On Top */}
            <div
              className="modal-body text-center py-5"
              style={{ position: "relative", zIndex: 10 }}
            >
             <motion.h2
  className="fw-bold mb-3 display-4"
  style={{

    WebkitBackgroundClip: "text",
    color: "white",

    fontWeight: "900",
    letterSpacing: "1px"
  }}
  initial={{ opacity: 0, y: -20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ delay: 0.3, duration: 0.6 }}
>
🚀 Now Live in Delhi
</motion.h2>


              <motion.p
                className="lead mb-4"
                style={{
                  color: "#fff",
                  textShadow: "1px 1px 3px rgba(0,0,0,0.3)"
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.6 }}
              >
                Courier | Partyzone | Dinezone | Caters
              </motion.p>
           
          <motion.p
                className="lead mb-4"
                style={{
                  color: "#fff",
                  textShadow: "1px 1px 3px rgba(0,0,0,0.3)"
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.6 }}
              >
               📍 Expanding to more cities very soon!
              </motion.p>


           {/* App Store Buttons */}
        
            <motion.div
              className="d-flex justify-content-center gap-3 flex-wrap"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.6 }}
            >
              {/* Play Store */}
              <a
                href="https://play.google.com/store/apps/details?id=com.katchit.customer_app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="../assets/play_store.avif"
                  alt="Google Play"
                  height="55"
                  style={{ cursor: "pointer" }}
                />
              </a>
            
              {/* App Store (can be updated later when available) */}
               <a
                href="https://apps.apple.com/in/app/katchit-customer/id6785157187"
                target="_blank"
                rel="noopener noreferrer"
              >
                  
              <img
                src="../assets/app_store.avif"
                alt="App Store"
                height="55"
                style={{ cursor: "pointer" }}
              />
            </a>
            </motion.div>

                 <motion.p
                className="lead mb-4"
                style={{
                  color: "#fff",
                  textShadow: "1px 1px 3px rgba(0,0,0,0.3)"
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.6 }}
              >
               Food delivery coming soon!
              </motion.p>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  )}
</AnimatePresence>




    </div>
  )
}

export default App
